export enum OperationType {
  Equal,
  NotEqual,
  Great,
  GreatOrEqual,
  Less,
  LessOrEqual,
  Contains,
}

interface OperationTypeSpec {
  id: number;
  description: string;
}

export function getType(type: OperationType): OperationTypeSpec {
  switch (type) {
    case OperationType.Great:
      return { id: 0, description: "Больше" };
    case OperationType.GreatOrEqual:
      return { id: 1, description: "Больше или равно" };
    case OperationType.Equal:
      return { id: 2, description: "Равно" };
    case OperationType.Less:
      return { id: 3, description: "Меньше" };
    case OperationType.LessOrEqual:
      return { id: 4, description: "Меньше или равно" };
    case OperationType.NotEqual:
      return { id: 5, description: "Не равно" };
    case OperationType.Contains:
      return { id: 6, description: "Содержит" };
  }
}
